import { Navigate } from "react-router-dom";
import { isUserLoggedIn } from "./utils/helpers";

function PrivateRoute({ children }) {
  if (!isUserLoggedIn()) {
    // not logged in so redirect to login page with the return url
    return <Navigate to="/login" />;
  }

  // authorized so return child components
  return children;
}
export { PrivateRoute };
